'use client';

import { ConfigProvider } from 'antd';
import type { Locale } from 'antd/lib/locale';
import dayjs from 'dayjs';
import localeData from 'dayjs/plugin/localeData';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import { useEffect, useState } from 'react';

dayjs.extend(localeData);
dayjs.extend(localizedFormat);
import { useAppContext } from '@/app/core/AppContext';

export function AntdProvider({ children }: { children: React.ReactNode }) {
  const { language } = useAppContext();
  const [locale, setLocale] = useState<Locale>();

  useEffect(() => {
    // we want nordic locale for English users
    const lang = language === 'en_US' ? 'en_GB' : language;
    const locale = lang.startsWith('en_') ? 'en-gb' : lang.split('_')[0].toLowerCase();

    // Load both antd and dayjs locales based on the user's language preference.
    // Needs to be loaded dynamically, since we don't want to include all locales in the bundle.
    Promise.all([import(`antd/locale/${lang}.js`), import(`dayjs/locale/${locale}.js`)])
      .then(([antdMod]) => {
        dayjs.locale(locale);
        setLocale(antdMod.default);
      })
      .catch((e) => console.error('Locale load failed:', e));
  }, [language]);

  return (
    <ConfigProvider theme={{ hashed: false }} locale={locale} spin={{ indicator: <i className="fa-solid fa-spinner fa-spin" /> }}>
      {children}
    </ConfigProvider>
  );
}
